export default __webpack_public_path__ + "static/media/bannerCrisBarrosMobile.438bbe51.svg";